import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { FORGET_USER, UPDATE_PW } from './actionTypes';

// AUTH related methods
import { forgetUser, forgetUserSuccessful, updatePW, updatePWSuccessful } from './actions';
import { forgotPWapi, updatePWApi } from './forgotPWapi';
import { apiError } from '../login/actions';

//If user is login then dispatch redux action's are directly from here.
function* forgetUserSaga({ payload:  user  }) {
  try {
    const response = yield call(forgotPWapi, user)
    yield put(forgetUserSuccessful(response));

  } catch (error) {
    yield put(apiError(error));
  }
}
function* updatePWSaga({ payload: { user } }) {

  try {
    const response = yield call(updatePWApi, user)
    yield put(updatePWSuccessful(response));

  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchUserForget() {
  yield takeEvery(FORGET_USER, forgetUserSaga)
  yield takeEvery(UPDATE_PW, updatePWSaga)
}

function* forgetSaga() {
  yield all([fork(watchUserForget)]);
}

export default forgetSaga;